import { render } from "./ChartsData.vue?vue&type=template&id=06076361"
import script from "./ChartsData.vue?vue&type=script&lang=js"
export * from "./ChartsData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__